import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import fin1 from '../../assets/images/virtualstart/fin_up1.png';
import fin2 from '../../assets/images/virtualstart/fin_up2.png';
import fin3 from '../../assets/images/virtualstart/fin_up3.png';
import fin4 from '../../assets/images/virtualstart/fin_up4.jpg';
import fin5 from '../../assets/images/virtualstart/fin_dwn1.jpg';
import fin6 from '../../assets/images/virtualstart/fin_dwn2.png';
import fin7 from '../../assets/images/virtualstart/fin_dwn3.png';
import fin8 from '../../assets/images/virtualstart/fin_dwn4.png';
import { Link, useNavigate } from "react-router-dom";


import './virtualstart_styles/finished.css';

export default function StartFinished() {
  
  const navigate = useNavigate();

  return (
    <>
      <Container className='mt-5 mb-5 start_finished'>
        <Row>
          <Col>
            <h2>Finished</h2>
          </Col>
        </Row>  
        <Row>
          <Col xl={3} lg={6} className='mt-3'>
            <Card className='fin_card' onClick={()=>navigate("/virtualstart/furthur")}>
            <Card.Img variant="top" src={fin1} className='img-fluid' />
              <div className="card-body">
                <div className="fin_card_btns d-flex gap-3">
                  <Button>NONINITIAL</Button>
                  <Button>Airdrop</Button>
                </div>
                <h5 className='card-title'>GoMining GOMINING</h5>
                <div className="fin_card_raise d-flex justify-content-between">
                  <p>raised</p>
                  <span>71,073,120 USDT</span>
                </div>
                <div className="fin_card_goal d-flex justify-content-between">
                  <p>Goal reached</p>
                  <span>44,420.70%</span>
                </div>
              </div>
            </Card>
          </Col>
          <Col xl={3} lg={6} className='mt-3'>
            <Card className='fin_card' onClick={()=>navigate("/virtualstart/furthur")}>
            <Card.Img variant="top" src={fin2} className='img-fluid' />
              <div className="card-body">
                <div className="fin_card_btns d-flex gap-3">
                  <Button>NONINITIAL</Button>
                  <Button>Airdrop</Button>
                </div>
                <h5 className='card-title'>Dione Protocol DIONE</h5>
                <div className="fin_card_raise d-flex justify-content-between">
                  <p>raised</p>
                  <span>71,116,400 USDT</span>
                </div>
                <div className="fin_card_goal d-flex justify-content-between">
                  <p>Goal reached</p>
                  <span>177,791.00%</span>
                </div>
              </div>
            </Card>
          </Col>
          <Col xl={3} lg={6} className='mt-3'>
            <Card className='fin_card' onClick={()=>navigate("/virtualstart/furthur")}>
            <Card.Img variant="top" src={fin3} className='img-fluid' />
              <div className="card-body">
                <div className="fin_card_btns d-flex gap-3">
                  <Button>NONINITIAL</Button>
                  <Button>Airdrop</Button>
                </div>
                <h5 className='card-title'>BRN Metaverse BRN</h5>
                <div className="fin_card_raise d-flex justify-content-between">
                  <p>raised</p>
                  <span>72,627,200 USDT</span>
                </div>
                <div className="fin_card_goal d-flex justify-content-between">
                  <p>Goal reached</p>
                  <span>72,627.20%</span>
                </div>
              </div>
            </Card>
          </Col>
          <Col xl={3} lg={6} className='mt-3'>
            <Card className='fin_card' onClick={()=>navigate("/virtualstart/furthur")}>
            <Card.Img variant="top" src={fin4} className='img-fluid' />
              <div className="card-body">
                <div className="fin_card_btns d-flex gap-3">
                  <Button>NONINITIAL</Button>
                  <Button>Airdrop</Button>
                </div>
                <h5 className='card-title'>Sharbi SHARBI</h5>
                <div className="fin_card_raise d-flex justify-content-between">
                  <p>raised</p>
                  <span>72,528,880 USDT</span>
                </div>
                <div className="fin_card_goal d-flex justify-content-between">
                  <p>Goal reached</p>
                  <span>145,057.76%</span>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
        <Row className='mt-5'>
          <Col xl={3} lg={6} className='mt-3'>
            <Card className='fin_card' onClick={()=>navigate("/virtualstart/furthur")}>
            <Card.Img variant="top" src={fin5} className='img-fluid' />
              <div className="card-body">
                <div className="fin_card_btns d-flex gap-3">
                  <Button>NONINITIAL</Button>
                  <Button>Airdrop</Button>
                </div>
                <h5 className='card-title'>Treecle TRCL</h5>
                <div className="fin_card_raise d-flex justify-content-between">
                  <p>raised</p>
                  <span>71,679,340 USDT</span>
                </div>
                <div className="fin_card_goal d-flex justify-content-between">
                  <p>Goal reached</p>
                  <span>110,275.91%</span>
                </div>
              </div>
            </Card>
          </Col>
          <Col xl={3} lg={6} className='mt-3'>
            <Card className='fin_card' onClick={()=>navigate("/virtualstart/furthur")}>
            <Card.Img variant="top" src={fin6} className='img-fluid' />
              <div className="card-body">
                <div className="fin_card_btns d-flex gap-3">
                  <Button>NONINITIAL</Button>
                  <Button>Airdrop</Button>
                </div>
                <h5 className='card-title'>REKT REKT</h5>
                <div className="fin_card_raise d-flex justify-content-between">
                  <p>raised</p>
                  <span>55,152,980 USDT</span>
                </div>
                <div className="fin_card_goal d-flex justify-content-between">
                  <p>Goal reached</p>
                  <span>183,843.27%</span>
                </div>
              </div>
            </Card>
          </Col>
          <Col xl={3} lg={6} className='mt-3'>
            <Card className='fin_card' onClick={()=>navigate("/virtualstart/furthur")}>
            <Card.Img variant="top" src={fin7} className='img-fluid' />
              <div className="card-body">
                <div className="fin_card_btns d-flex gap-3">
                  <Button>NONINITIAL</Button>
                  <Button>Airdrop</Button>
                </div>
                <h5 className='card-title'>Bear Inu BEAR</h5>
                <div className="fin_card_raise d-flex justify-content-between">
                  <p>raised</p>
                  <span>64,792,500 USDT</span>
                </div>
                <div className="fin_card_goal d-flex justify-content-between">
                  <p>Goal reached</p>
                  <span>53,993.75%</span>
                </div>
              </div>
            </Card>
          </Col>
          <Col xl={3} lg={6} className='mt-3'>
            <Card className='fin_card' onClick={()=>navigate("/virtualstart/furthur")}>
            <Card.Img variant="top" src={fin8} className='img-fluid' />
              <div className="card-body">
                <div className="fin_card_btns d-flex gap-3">
                  <Button>NONINITIAL</Button>
                  <Button>Airdrop</Button>
                </div>
                <h5 className='card-title'>PROJECT XENO GXE</h5>
                <div className="fin_card_raise d-flex justify-content-between">
                  <p>raised</p>
                  <span>65,328,960 USDT</span>
                </div>
                <div className="fin_card_goal d-flex justify-content-between">
                  <p>Goal reached</p>
                  <span>65,328.96%</span>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>    
    </>
  )
}